import React, { useState } from 'react';
import { Container, Row, Col, Card, Form, Button, Alert } from 'react-bootstrap';

const Contact = () => {
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    subject: '',
    message: ''
  });
  const [submitted, setSubmitted] = useState(false);

  const handleSubmit = (e) => {
    e.preventDefault();
    // In a real app, you would send this to a backend
    console.log('Form submitted:', formData);
    setSubmitted(true);
    setFormData({ name: '', email: '', subject: '', message: '' });
    
    // Reset submission status after 5 seconds
    setTimeout(() => setSubmitted(false), 5000);
  };

  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value
    });
  };

  return (
    <Container className="py-5">
      <h1 className="display-4 mb-4 text-center">Contact Us</h1>
      <p className="lead text-center mb-5">
        Get in touch with us for any queries or information
      </p>

      <Row>
        <Col lg={6} className="mb-4">
          <Card className="shadow-sm h-100">
            <Card.Body>
              <Card.Title className="mb-4">
                <i className="fas fa-map-marker-alt me-2 text-primary"></i>
                Our Location
              </Card.Title>
              
              <div className="mb-4">
                <h5>College Address</h5>
                <p className="mb-0">
                  Your College Name<br />
                  College Street, College Area<br />
                  City, State - 123456<br />
                  Country
                </p>
              </div>

              <div className="mb-4">
                <h5>Contact Information</h5>
                <p className="mb-2">
                  <i className="fas fa-phone me-2 text-primary"></i>
                  +91 12345 67890
                </p>
                <p className="mb-2">
                  <i className="fas fa-fax me-2 text-primary"></i>
                  +91 12345 67891
                </p>
                <p className="mb-2">
                  <i className="fas fa-envelope me-2 text-primary"></i>
                  info@college.edu
                </p>
                <p className="mb-0">
                  <i className="fas fa-globe me-2 text-primary"></i>
                  www.college.edu
                </p>
              </div>

              <div>
                <h5>Office Hours</h5>
                <p className="mb-0">
                  Monday - Friday: 9:00 AM - 5:00 PM<br />
                  Saturday: 9:00 AM - 1:00 PM<br />
                  Sunday: Closed
                </p>
              </div>
            </Card.Body>
          </Card>
        </Col>

        <Col lg={6}>
          <Card className="shadow-sm">
            <Card.Body>
              <Card.Title className="mb-4">Send us a Message</Card.Title>
              
              {submitted && (
                <Alert variant="success" className="mb-4">
                  <i className="fas fa-check-circle me-2"></i>
                  Thank you for your message! We'll get back to you soon.
                </Alert>
              )}
              
              <Form onSubmit={handleSubmit}>
                <Form.Group className="mb-3">
                  <Form.Label>Full Name *</Form.Label>
                  <Form.Control
                    type="text"
                    name="name"
                    value={formData.name}
                    onChange={handleChange}
                    required
                    placeholder="Enter your name"
                  />
                </Form.Group>

                <Form.Group className="mb-3">
                  <Form.Label>Email Address *</Form.Label>
                  <Form.Control
                    type="email"
                    name="email"
                    value={formData.email}
                    onChange={handleChange}
                    required
                    placeholder="Enter your email"
                  />
                </Form.Group>

                <Form.Group className="mb-3">
                  <Form.Label>Subject *</Form.Label>
                  <Form.Control
                    type="text"
                    name="subject"
                    value={formData.subject}
                    onChange={handleChange}
                    required
                    placeholder="Enter subject"
                  />
                </Form.Group>

                <Form.Group className="mb-4">
                  <Form.Label>Message *</Form.Label>
                  <Form.Control
                    as="textarea"
                    rows={5}
                    name="message"
                    value={formData.message}
                    onChange={handleChange}
                    required
                    placeholder="Enter your message"
                  />
                </Form.Group>

                <Button 
                  type="submit" 
                  variant="primary" 
                  size="lg"
                  className="w-100"
                >
                  <i className="fas fa-paper-plane me-2"></i>
                  Send Message
                </Button>
              </Form>
            </Card.Body>
          </Card>
        </Col>
      </Row>

      {/* Map Section */}
      <Row className="mt-5">
        <Col>
          <Card className="shadow-sm">
            <Card.Body className="p-0">
              <div style={{ height: '400px', width: '100%' }}>
                {/* This would be a real Google Maps embed */}
                <div style={{
                  height: '100%',
                  width: '100%',
                  backgroundColor: '#f8f9fa',
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  border: '1px solid #dee2e6'
                }}>
                  <div className="text-center">
                    <i className="fas fa-map fa-3x text-muted mb-3"></i>
                    <h5>Interactive Map</h5>
                    <p className="text-muted">Map would be displayed here</p>
                  </div>
                </div>
              </div>
            </Card.Body>
          </Card>
        </Col>
      </Row>
    </Container>
  );
};

export default Contact;